<template>
  <AppStrip class="strip py-3">
    <p v-html="announcement" />
  </AppStrip>
</template>

<script setup lang="ts">
defineProps<{
  announcement: string;
}>();
</script>

<style scoped>
.strip {
  position: relative;
  z-index: 1;
  font-weight: 500;
}
</style>